import type { ScreenName } from '@helpcenter/constants';
import type { CustomPageElementViewRendererProps } from '@atlassian/help-center-custom-page-element-view-renderer/src/ui/custom-page-element-view-renderer';
import type { HomePageElementViewRendererProps } from '@atlassian/help-center-home-page-element-view-renderer/src/ui/home-page-element-view-renderer';
import type { UFOExperience } from '@atlassian/ufo';
export type SelectionType = 'section' | 'subsection';

export type Primitive = 'section' | 'subsection' | 'compositeElement' | 'atomicElement';
export interface MediaConfig {
    mediaUrl?: string | null;
    mediaToken?: string | null;
    mediaCollectionName?: string | null;
    asapIssuer?: string | null;
}
export interface LayoutPath {
    type: string;
    dataId: string;
    name: string;
}

export interface LayoutId {
    sectionId: string | undefined;
    elementId: string | undefined;
}

// eslint-disable-next-line no-shadow
export const enum PageType {
    HOME_PAGE = 'homepage',
    CUSTOM_PAGE = 'custom-page',
}

export interface State {
    isPageInEditMode: boolean;
    isPageInPreviewMode: boolean;
    isPublishing: boolean;
    isPublishDisabled: boolean;
    isDirty: boolean;
    ElementRenderer?: React.ComponentType<HomePageElementViewRendererProps | CustomPageElementViewRendererProps>;
    screenName?: ScreenName;
    experience?: UFOExperience;
    traceId?: string;
    mediaConfig: MediaConfig;
    deletedModulesCount: number;
    // TODO: Remove pageType from state when hero element config moves to backend
    pageType?: PageType;
    reorderedModulesCount: number;
    configPanel: {
        ui: React.ReactNode | null;
    };
    events: {
        selected?: {
            dataId: string;
            path: LayoutPath[];
        };
        hovered?: string;
        dragged?: string;
        sectionPickerId?: string;
    };
    isPageInBrandingPreviewMode: boolean;
    config: {
        hideCatalogue: boolean;
        canAddNewSections: boolean;
        canAddNewSubSections: boolean;
        canInteractWithSubSections: boolean;
        canInteractWithElements: boolean;
        canDeleteSections: boolean;
        newSectionCanOnlyAddEditor: boolean;
    };
    layoutIds: {
        HelpLayoutHeroElement: LayoutId;
        HelpLayoutAnnouncementElement: LayoutId;
        HelpLayoutTopicsListElement: LayoutId;
        HelpLayoutPortalsListElement: LayoutId;
        HelpLayoutSuggestedRequestFormsListElement: LayoutId;
        // Each forge, connect Element types can have multiple entries in a single page as a Header, footer, subheader and so on.
        HelpLayoutForgeElement: LayoutId[];
        HelpLayoutConnectElement: LayoutId[];
        HelpLayoutKnowledgeCardsElement: LayoutId;
    };
}

export type ImmutableState = Readonly<State>;

export interface Props {
    editMode?: boolean;
    ElementRenderer?: React.ComponentType<HomePageElementViewRendererProps | CustomPageElementViewRendererProps>;
    screenName?: ScreenName;
    experience?: UFOExperience;
    traceId?: string;
    mediaConfig?: MediaConfig;
    isDirty?: boolean;
    pageType?: PageType;
    config?: Partial<State['config']>;
    events?: Partial<State['events']>;
    configPanelUI?: React.ReactNode;
}
